// Module
var code = "<div class=edit-list-module><h4>Edit List Name</h4><form><input placeholder=\"{{ $ctrl.list.name }}\" ng-model=$ctrl.edits.name><button class=\"btn btn-sm btn-black\" ng-click=$ctrl.editGroup()>Save</button></form><p class=alert-error ng-if=!$ctrl.canEdit>A list name is required.</p></div>";
// Exports
module.exports = code;